import { TableUIProvider } from "../../../contexts/TableUIContext";
import Categories from "./Categories";

export default function CategoriesWrapper() {
    return (
        <TableUIProvider>
            <Categories />
        </TableUIProvider>
    );
}
